"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WineCarousel = void 0;
var React = require("react");
var StyleComponents_1 = require("./base/StyleComponents");
var react_multi_carousel_1 = require("react-multi-carousel");
require("react-multi-carousel/lib/styles.css");
var fa_1 = require("react-icons/fa");
var responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1400 },
        items: 3,
        slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
        breakpoint: { max: 1400, min: 464 },
        items: 2,
        slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    }
};
var wines = [
    {
        name: 'RIES',
        text: 'Wino o aromatach zielonego jabłka i cytrusów z delikatnymi nutami melona w tle wyczuwalne nuty mineralne i ziołowo-korzenne. Wino żywe, świeże, dobrze zbudowane, doskonale wytrawne, o owocowej i ujmującej końcówce. Wino serwować do ryb, owoców morza, ostrych serów i sałatek.',
        image: 'ries.png'
    },
    {
        name: 'HIBE',
        text: 'Wino o wysokim ekstrakcie, wyraźnych aromatach ziół, kwiatu czarnego bzu oraz tropikalnych owoców. W smaku wyraziste, ze zrównowa-żoną kwasowością. Wino jest żywe i rześkie. Wino serwować do drobiu, wędlin, delikatnych serów oraz schłodzone jak aperitif.',
        image: 'hibe.png'
    },
    {
        name: 'TRAMI',
        text: 'Wino charakteryzują bardzo ekspresyjne aromaty płatków róż, przypraw, ziół, herbaty. W ustach niezwykle delikatne i za-okrąglone. Pełne, miękkie a jednocześnie świeże, o niskiej kwasowości. Schłodzone znakomite jako aperitif. Polecane do kuchni azjatyckiej, ryb i owoców morza, białych mięs oraz serów pleśniowych.',
        image: 'trami.png'
    },
    {
        name: 'CHAR',
        text: 'Wino posiada intensywnie żółtą barwę, która jest wyrazem dojrzewania w kontakcie z dębem. Wino o intensywnym aromacie, wyczuwalny karmel, wanilia oraz orzechy. W smaku maślane, pełne, doskonale wyważone, końcówka bardzo owocowa i długa. Wino serwować do dojrzałych serów o mocnej, kremowej strukturze oraz twardych, długodojrzewających.Pasuje również do delikatnych białych mięs.',
        image: 'char.png'
    },
    {
        name: 'SEY',
        text: 'Wino o aromatach mięty, liści czarnej porzeczki oraz kwiatu czarnego bzu. Jednocześnie wyczuwalne aromaty owoców egzotycznych – pomarańczy, mango, ananasa. W smaku pełne i kremowe o solidnie zbudowanej równoważącej słodycz delikatnej kwasowości. Wino idealnie współgra z lodami, owocowymi deserami i cytrusami.',
        image: 'sey.png'
    },
    {
        name: 'KWIATOWE',
        text: 'Wino o delikatnie słomkowej barwie. Wino stanowi niepowtarzalną kompozycję intensywnych aromatów kwiatu lipy, miodu i jaśminu. W smaku wielowarstwowy bukiet zielonego jabłka, kwiatów i nut owoców pestkowych z żywą kwasowością.W końcówce pikantne z wyraźnymi nutami gałki muszkatowej. Wino serwować do serów pleśniowych, kozich, deserów oraz mocno schłodzone jako aperitif.',
        image: 'kwiatowe.png'
    },
    {
        name: 'GRIS',
        text: 'Wino solidnie zbudowane o aromatach kwiatów, limonki oraz białych owoców pestkowych. Lekko mineralne ze zbalansowaną kwasowością, dające uczucie świeżości, w końcówce lekko pikantne. Wino serwować do sałatek, serów twardych, ryb, owoców morza oraz białych sosów śmietanowych.',
        image: 'girs.png'
    },
    {
        name: 'HIBERIS',
        text: 'Wino o aromatach zielonego jabłka i cytrusów z delikatnymi nutami melona w tle wyczuwalne nuty mineralne i ziołowo-korzenne. Wino żywe, świeże, dobrze zbudowane, doskonale wytrawne, o owocowej i ujmującej końcówce. Wino serwować do ryb, owoców morza, ostrych serów i sałatek.',
        image: 'hiberis.png'
    },
    {
        name: 'ZŁOTE',
        text: 'Wino o słomkowej barwie ze złocistymi refleksami. Zamknięty jest w nim pełen aromat owocu winorośli oraz bogate nuty dojrzałego jabłka i przypraw. W smaku czyste i mineralne, o owocowym posmaku z pieprzną końcówką. Wino będzie pasować do niezbyt ciężkich potraw, takich jak drób, ryby, zupa- krem, makaron z sosem.Warto serwować je również wraz z przekąskami, takimi jak słone sery i prażone migdały.',
        image: 'złote.png'
    },
    {
        name: 'CZARNE',
        text: 'W nosie wyczuwalne czerwone owoce z wyraźną czarną porzeczką, jeżyną, wędzoną śliwką oraz kawowo-czekoladowymi nutami w tle. W smaku dobrze zbudowane, niezwykle ekstraktywne i intensywne.Całość wieńczy niezwykle długi i satysfakcjonujący finisz ujawniający wszelkie zalety odmiany Gołubok. Wino wyśmienicie komponuje się z dziczyzną, duszonym mięsem, wędzonymi, grillowanymi oraz pikantnymi potrawami.',
        image: 'czarne.png'
    },
    {
        name: 'REGERO',
        text: 'Klasyczne wino o głębokiej czerwonej barwie z fioletowym odcieniem. Bukiet wyraźnie owocowy, wyczuwalne wiśnie, czereśnie oraz owoce leśne połączone z nutami mineralnymi. W smaku aksamitne z wyczuwalną wanilią i taninami, zrównoważoną kwasowością i długim rześkim posmakiem. Wino podawać do czerwonych mięs, zapiekanek, tart warzywnych, dań z makaronu, wędlin oraz serów dojrzewających.',
        image: 'regero.png'
    },
    {
        name: 'MALGO',
        text: 'Wino o pięknej dojrzałej czerwonej barwie. Dominującymi aromatami, są owoce jagody, wiśni w tle nuty bzu i tytoniu. Pełne smaku, delikatne, owocowe, z umiarkowaną zawartością tanin, w ustach przyjemne, nie drażniące, ze zrównoważoną zawartością cukrów i kwasów. Wino komponuje się ze wszelkiego rodzaju pieczeniami, kaczką, gęsią oraz makaronami.',
        image: 'malgo.png'
    },
    {
        name: 'DORE',
        text: 'Wino o typowym dla odmiany dornfelder fioletowym odcieniu. W nosie wyczuwalne czerwone i czarne owoce - czereśnie, jeżyny, wiśnie oraz porzeczka. Na podniebieniu krągłe, doskona - le zbudowane, średniotaniczne z długim posmakiem. Sprawdzi się jako dodatek do niezbyt tłustych dań mięsnych, makaronów, grillowanych warzyw oraz serów o wyrazistym smaku.',
        image: 'dore.png'
    },
    {
        name: 'RÓŻOWE',
        text: 'Wino o jasnej łososiowej barwie. W aromacie intensywny zapach świeżych truskawek i poziomek. Lekkie i perliste, świeże, o wyrafinowanym smaku dojrzałej słodkiej truskawki z delikatnie wyczuwalną kwasowością.Idealne na lato. Wino serwować do sałatek owocowych, sezonowych letnich warzyw delikatnych serów oraz lodów.',
        image: 'różowe.png'
    },
];
var WineCarousel = function () {
    return (React.createElement("div", { style: {
            paddingBottom: '2em',
            paddingTop: '2em',
            textAlign: 'center',
            //backgroundImage: 'url(image/pattern/dots3.png)',
            //backgroundRepeat: 'repeat',
            backgroundImage: 'linear-gradient(black 5%, transparent 50%, black 95%), linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(image/gallery/8.jpg)',
            backgroundSize: 'cover',
            //backgroundImage: 'linear-gradient(black 5%, #085610 60%, black 95%), linear-gradient(#085610 40%, white 60%, #085610 80%)', 
            zIndex: 100000
        } },
        React.createElement("div", { style: { width: '100%', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', padding: '.5em 2em .2em 2em' } },
            React.createElement("div", { style: {
                    width: '30%',
                    minWidth: 320,
                    color: StyleComponents_1.goldColor,
                } },
                React.createElement("span", { style: { color: 'white', letterSpacing: '.3em' } }, "POZNAJ"),
                React.createElement("h1", null,
                    React.createElement("b", null, "NASZE WINA")),
                React.createElement("hr", null)),
            React.createElement("a", { style: {
                    height: 65,
                    fontSize: 18,
                    color: StyleComponents_1.goldColor,
                    textDecorationLine: 'none',
                    border: '2px solid rgb(193, 135, 6)',
                    borderRadius: 30,
                    padding: '1em 1em 0em 1em'
                }, href: "http://sklep.winnicaswidnicka.eu" },
                React.createElement(fa_1.FaShoppingCart, null),
                "  KUP TERAZ")),
        React.createElement("div", null,
            React.createElement(react_multi_carousel_1.default, { draggable: true, swipeable: true, autoPlay: false, autoPlaySpeed: 99999999999999, infinite: true, deviceType: 'desktop', itemClass: "image-item", responsive: responsive, removeArrowOnDeviceType: ["tablet", "mobile"], showDots: true, arrows: false, containerClass: "carousel-container" }, wines.map(function (w) { return React.createElement(WineCarouselItem, { wine: w }); })))));
};
exports.WineCarousel = WineCarousel;
var WineCarouselItem = function (_a) {
    var wine = _a.wine;
    return (React.createElement("div", { style: {
            height: '80vh',
            maxWidth: 500,
            display: 'flex',
            columnGap: '2em',
            justifyContent: 'center',
            alignItems: 'center',
            //backgroundColor: goldColor
            color: 'white',
            paddingLeft: '1em',
            paddingRight: '1em',
            marginBottom: '1em'
        } },
        React.createElement("div", { style: {
                //backgroundColor: 'rgba(255,255,255,0.6)',
                //boxShadow: '0 0 50px 50px rgba(255,255,255,0.6)',
                color: 'white',
            } },
            React.createElement("h2", null,
                React.createElement("b", null, wine.name)),
            React.createElement("hr", null),
            React.createElement("p", { style: {
                    color: StyleComponents_1.goldColor,
                    fontSize: window.innerWidth <= 464 ? 12 : 'auto'
                } },
                React.createElement("b", null, wine.text))),
        React.createElement("img", { src: "image/wine/" + wine.image, style: {
                height: '85%'
            }, onClick: function (e) { e.preventDefault(); }, onDragStart: function (e) { e.preventDefault(); } })));
};
//# sourceMappingURL=WineCarousel.js.map